import * as Yup from 'yup'
import { CargoType, createValidation } from '../../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

type OpcaoCargo = { value?: CargoType } | null | undefined

/**
 * Médico sempre informa o registro completo. Solicitante pode não ter conselho; se informar o
 * número, UF e conselho passam a ser obrigatórios para o registro ficar completo.
 */
const registroObrigatorio = (cargo: OpcaoCargo, crm?: string) =>
  cargo?.value === CargoType.Medico || (cargo?.value === CargoType.Solicitante && !!crm)

export const vincularSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    cargo: Yup.object().nullable().required(v.requiredField('cargo', 'select')),

    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),

    uf: Yup.object()
      .nullable()
      .when(['cargo', 'crm'], {
        is: registroObrigatorio,
        then: (schema) => schema.required('Selecione a UF do conselho'),
        otherwise: (schema) => schema.notRequired(),
      }),

    crm: Yup.string().when('cargo.value', {
      is: CargoType.Medico,
      then: (schema) => schema.required('Número do Conselho de Classe é obrigatório'),
      otherwise: (schema) => schema.notRequired(),
    }),

    conselho: Yup.object()
      .nullable()
      .when(['cargo', 'crm'], {
        is: registroObrigatorio,
        then: (schema) => schema.required('Conselho é obrigatório'),
        otherwise: (schema) => schema.notRequired(),
      }),

    email: Yup.string().email('E-mail inválido').required('Email é obrigatório'),
    vinculo: Yup.object().nullable().notRequired(),
  })
}
